/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IBranding<T> {
  readonly _brand: T;
}

export type TBrand<T, BRANDING> = T & IBranding<BRANDING>;

export function brandNumber<BRAND extends TBrand<number, any>>(n: number): BRAND;
export function brandNumber<BRAND extends TBrand<number, any>>(n: number | null): BRAND | null;
export function brandNumber<BRAND extends TBrand<number, any>>(n: number | undefined): BRAND | undefined;
export function brandNumber<BRAND extends TBrand<number, any>>(n: number | null | undefined): BRAND | null | undefined;
export function brandNumber<BRAND extends TBrand<number, any>>(n: number | null | undefined): BRAND | null | undefined {
  return n as BRAND | null | undefined;
}

export function brandString<BRAND extends TBrand<string, any>>(s: string): BRAND;
export function brandString<BRAND extends TBrand<string, any>>(s: string | null): BRAND | null;
export function brandString<BRAND extends TBrand<string, any>>(s: string | undefined): BRAND | undefined;
export function brandString<BRAND extends TBrand<string, any>>(s: string | null | undefined): BRAND | null | undefined;
export function brandString<BRAND extends TBrand<string, any>>(s: string | null | undefined): BRAND | null | undefined {
  return s as BRAND | null | undefined;
}
